import { render, staticRenderFns } from "./PackagesInCarrierBag.vue?vue&type=template&id=45cfc656&scoped=true&"
import script from "./PackagesInCarrierBag.vue?vue&type=script&lang=js&"
export * from "./PackagesInCarrierBag.vue?vue&type=script&lang=js&"
import style0 from "./PackagesInCarrierBag.vue?vue&type=style&index=0&id=45cfc656&lang=scss&scoped=true&"
import style1 from "./PackagesInCarrierBag.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cfc656",
  null
  
)

export default component.exports